export const popoverTheme = {
   light: {
      borderColor: 'border-gray-200',
      background: 'bg-base-white'
   },
   dark: {}
}
